"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAndValidateData = exports.shouldSkipDefaultPrefix = void 0;
var validators_1 = require("../validators");
/**
 * Helper function to check based on configuration options whether to add the "cvent_" to
 * the data attributes/ properties
 */
var shouldSkipDefaultPrefix = function (options) {
    return (options === null || options === void 0 ? void 0 : options.skipDeprecatedDefaultPrefix) === true;
};
exports.shouldSkipDefaultPrefix = shouldSkipDefaultPrefix;
/**
 * Helper function to do any cleaning/transformation/validation of data before data is sent.
 *
 * @param data The data to manipulate
 * @param skipAttributes A list of data properties/attributes we want to ignore to process.
 * @param options The reporter configuration options used to decide on how/if the data need to be manipulated
 */
var transformAndValidateData = function (data, skipAttributes, options) {
    if (data) {
        var prefix = (0, exports.shouldSkipDefaultPrefix)(options) ? '' : 'cvent_';
        var skipAttributesSet = new Set(skipAttributes);
        var transformedData = {};
        for (var _i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (skipAttributesSet.has(key)) {
                transformedData[key] = value;
            }
            else {
                (0, validators_1.verifyTag)(key, options);
                transformedData["".concat(prefix).concat(key)] = value;
            }
        }
        return transformedData;
    }
    return data;
};
exports.transformAndValidateData = transformAndValidateData;
